import { h } from '@stencil/core';
import state from 'store';
import { i18n } from 'i18n';
import { sendFeedback } from 'client';
import { triggerTrackEvent } from 'utils/events';
import { buildRequestContext } from 'client/helper';
import initParams from 'store/initParams';
import { closeDialog } from 'utils/ui';

export default function FeedbackFormModal() {
  const MAX_LENGTH_QUESTION_1 = 500;

  const onClose = () => {
    closeDialog('feedback-form-modal');
  };

  const onSend = () => {
    triggerTrackEvent({
      event_type: 'user',
      event_name: `feeback_form_send`,
      data: {
        score: state.feedbackForm.score.toString(10),
      },
    });

    sendFeedback(
      state.chatId!,
      {
        score: state.feedbackForm.score,
        question1: state.feedbackForm.question1,
      },
      buildRequestContext(state, initParams),
    )
      .then(() => {
        // console.log(`Succesfully feedback message ${state.feedback.messageId} with type ${state.feedback.type}`);
        state.feedbackForm = {
          score: -1,
          question1: '',
          sent: true,
        };
      })
      .catch(e => {
        triggerTrackEvent({
          event_type: 'system',
          event_name: `feeback_form_send_fail`,
          data: {
            score: state.feedbackForm.score.toString(10),
          },
        });
        console.error(e);
      })
      .finally(() => {
        onClose();
      });
  };

  return (
    <dialog
      id={'feedback-form-modal'}
      role="alertdialog"
      class={{
        'eva-3-modal -show-sticky-footer -smooth-scroll fullscreen-modal -show-modal': true,
      }}
    >
      <div class="modal-header" role="presentation">
        <div class="modal-title-container">
          <h4 class="eva-3-h4 modal-title">{i18n.t.feedbackForm.title}</h4>
        </div>
        <i
          class="eva-3-icon-cross modal-close -eva-3-mr-md"
          role="button"
          tabindex="0"
          aria-label={i18n.t.feedbackForm.close}
          onClick={() => {
            triggerTrackEvent({
              event_type: 'user',
              event_name: `feeback_form_close`,
            });
            onClose();
          }}
        ></i>
      </div>
      <div class="modal-content" role="presentation">
        <p class="eva-3-h6 -eva-3-mb-lg">{i18n.t.feedbackForm.question1}</p>
        <div
          class={{
            'eva-3-nps -eva-3-mb-xxlg': true,
            [state.feedbackForm.score >= 0 ? `-selected-${state.feedbackForm.score}` : '']: true,
          }}
        >
          {/*<div class="eva-3-h5 nps-title -eva-3-mb-lg">{i18n.t.feedbackForm.question1}</div>*/}
          {/*{state.feedbackForm.score > 0 ? <p class="nps-status">5: Poco Probable</p> : null}*/}
          <div class="nps-container">
            <ul class="nps-options">
              <span role="button" tabindex="0" class="nps-option -eva-3-hide-large -eva-3-hide-medium">
                N/A
              </span>

              {Array.from({ length: 11 }, (_, i) => {
                return (
                  <span
                    class="eva-3-tooltip -sm -white -top -center nps-option"
                    onClick={() => {
                      triggerTrackEvent({
                        event_type: 'user',
                        event_name: `feeback_form_change_score`,
                        data: {
                          score: i.toString(10),
                        },
                      });

                      state.feedbackForm = {
                        ...state.feedbackForm,
                        score: i,
                      };
                    }}
                  >
                    <span>{i}</span>
                  </span>
                );
              })}
            </ul>

            <div class="nps-input-container">
              <div class="nps-input-content">
                <input
                  class="nps-input"
                  type="range"
                  min="0"
                  max="10"
                  step="1"
                  onChange={event => {
                    const score = Number((event.currentTarget as HTMLInputElement).value);

                    triggerTrackEvent({
                      event_type: 'user',
                      event_name: `feeback_form_change_score`,
                      data: {
                        score: score.toString(10),
                      },
                    });

                    state.feedbackForm = {
                      ...state.feedbackForm,
                      score: score,
                    };
                  }}
                  value={state.feedbackForm.score}
                />
              </div>
              <span class="nps-input-help-caption -eva-3-fl">Poco probable</span>
              <span class="nps-input-help-caption -eva-3-fr">Muy probable</span>
            </div>
          </div>
        </div>

        <p class="eva-3-h6 -eva-3-mb-lg">{i18n.t.feedbackForm.question2}</p>
        <div class="eva-3-textarea -lg">
          <div class="textarea-container">
            <textarea
              class="textarea-tag"
              value={state.feedbackForm.question1}
              onKeyUp={event => {
                state.feedbackForm = {
                  ...state.feedbackForm,
                  question1: (event.target as HTMLTextAreaElement).value,
                };
              }}
              placeholder={i18n.t.feedbackForm.placeholder2}
              rows={4}
              data-twofas-input-listener="true"
              maxlength={MAX_LENGTH_QUESTION_1}
            ></textarea>
          </div>
          <span class="textarea-message">{i18n.t.chat.textarea.remaining(MAX_LENGTH_QUESTION_1 - state.feedbackForm.question1.length, MAX_LENGTH_QUESTION_1)}</span>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="eva-3-btn -lg -primary" onClick={onSend} disabled={state.feedbackForm.score === -1}>
          <em class="btn-text">{i18n.t.feedbackForm.send}</em>
        </button>
      </div>
    </dialog>
  );
}
